import React from 'react';

import { FormattedMessage } from 'react-intl';

import { Box, Inline, Text, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { messages } from './messages.tsx';

export type SupportedKey = keyof typeof messages;
export type Injections = {
	additionalObject?: React.ReactNode;
	svgBody: React.ReactNode;
};

type Props = {
	projectName: string | undefined;
	activeView: SupportedKey;
	injections: Injections;
};

const tabNavList: SupportedKey[] = ['board', 'list', 'timeline', 'backlog'];

export const ProjectSvg = ({ projectName, activeView, injections }: Props) => {
	const svgWidth = 506;
	const additionalObject = injections.additionalObject;
	const viewSvg = injections.svgBody;
	return (
		<svg
			width={svgWidth}
			height="416"
			viewBox={`0 0 ${svgWidth} 416`}
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden
		>
			<g clipPath="url(#clip0_2056_22194)">
				<rect
					x="212.766"
					y="20.3813"
					width="279.448"
					height="381.336"
					transform="rotate(-1.95711 212.766 20.3813)"
					fill="#FFA900"
				/>
				<rect width="264" height="416" fill="#1868DB" />
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M263.999 18.6309V400.19L225.789 401.496L212.766 20.3816L263.999 18.6309Z"
					fill="#09326C"
				/>
			</g>
			<rect width="442" height="331" transform="translate(32 48)" fill="white" />
			<rect x="362" y="76" width="24" height="16" fill="#F1F2F4" />
			<rect x="394" y="76" width="24" height="16" fill="#F1F2F4" />
			<rect x="426" y="76" width="24" height="16" fill="#F1F2F4" />
			<foreignObject width={150} height={24} x={56} y={66}>
				<Box xcss={truncatedHeadingStyles}>{projectName}</Box>
			</foreignObject>
			<foreignObject width={220} height={24} x={56} y={98}>
				<Inline space="space.200">
					{tabNavList.map((nav) => (
						<Text key={nav} color={nav === activeView ? 'color.text' : 'color.text.disabled'}>
							<Box xcss={smallHeadingStyles}>
								<FormattedMessage {...messages[nav]} />
							</Box>
						</Text>
					))}
				</Inline>
			</foreignObject>
			<foreignObject width={394} height={223} x={56} y={132}>
				{viewSvg}
			</foreignObject>
			{additionalObject}
		</svg>
	);
};
const smallHeadingStyles = xcss({
	font: token('font.heading.xxsmall'),
});
const truncatedHeadingStyles = xcss({
	width: '150px',
	height: '24px',
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	font: token('font.heading.small'),
});
